import { format, parseISO } from 'date-fns';
import {
  CreditCard,
  CalendarBlank,
  Repeat,
  Clock,
  ClipboardText,
} from '@phosphor-icons/react';

export const API_URL = (typeof window !== 'undefined' && window.location.hostname && !/^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname)) ? window.location.origin : process.env.REACT_APP_BACKEND_URL;

export const categories = [
  { value: 'all', label: 'All' },
  { value: 'bill', label: 'Bills' },
  { value: 'appointment', label: 'Appointments' },
  { value: 'subscription', label: 'Subscriptions' },
  { value: 'task', label: 'Tasks' },
  { value: 'general', label: 'General' }
];

export const recurrenceOptions = [
  { value: 'none', label: 'One-time' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'fortnightly', label: 'Fortnightly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'yearly', label: 'Yearly' }
];

export const recurrenceLabel = (val) => recurrenceOptions.find(r => r.value === val)?.label || val;

export const currencySymbols = {
  USD: 'US$', AUD: 'A$', SGD: 'S$', INR: '₹', EUR: '€', GBP: '£',
  NZD: 'NZ$', CAD: 'C$', JPY: '¥', CNY: '¥', KRW: '₩', MYR: 'RM',
};

export const formatAmount = (amount, currency) => {
  if (amount == null) return '-';
  const symbol = currencySymbols[currency] || (currency ? currency + ' ' : '$');
  return `${symbol}${amount.toFixed(2)}`;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return 'No date';
  try {
    const date = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;
    return format(date, 'MMM dd, yyyy');
  } catch {
    return 'Invalid date';
  }
};

export const isOverdue = (dateStr) => {
  if (!dateStr) return false;
  try {
    const date = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;
    return date < new Date();
  } catch {
    return false;
  }
};

export const getCategoryIcon = (category) => {
  switch (category) {
    case 'bill': return <CreditCard size={20} className="text-[#9d1f2d]" weight="duotone" />;
    case 'subscription': return <Repeat size={20} className="text-[#5b21b6]" weight="duotone" />;
    case 'appointment': return <CalendarBlank size={20} className="text-[#005bc1]" weight="duotone" />;
    case 'task': return <ClipboardText size={20} className="text-[#b45309]" weight="duotone" />;
    default: return <Clock size={20} className="text-[#596065]" weight="duotone" />;
  }
};

export const getPriorityColor = (priority) => {
  if (priority >= 80) return 'bg-[#ff8b9a] text-[#410002]';
  if (priority >= 50) return 'bg-[#fff3cd] text-[#856404]';
  return 'bg-[#a3f5b8] text-[#0f6b3a]';
};
